module.exports = __webpack_public_path__ + "static/media/woocommerce.a4cc5692.svg";